import React from 'react';

const TopProgressBar: React.FC<{ isActive: boolean }> = ({ isActive }) => {
  return <div className={`top-progress${isActive ? ' is-active' : ''}`} aria-hidden="true" />;
};

export default TopProgressBar;
